import React, {Component}         from 'react';
import {connect}                  from 'react-redux';
import MissaoRespostaList         from './missao_resposta_list';
import FlashCarregando            from '../../../container/FlashCarregando';
import { GetComponentesTarefas }  from '../../../actions/tarefaAction';
import { SetError }               from '../../../actions/authenticActions';
import { GetListaMenuTopo,
         GetListaSubMenuTopo,
         GetCheckSelect}     from '../../../actions/scopoAction';

class Missao_Resposta extends Component {

   constructor(props){
        super(props)
        this.state = {
                      load   : false,
                      dis_id : this.props.match.params.id1,
                      tar_id : this.props.match.params.id2, 
                      tur_id : this.props.match.params.id3 
                     }
                    
    }

    componentWillMount(){
       
        this.props.GetComponentesTarefas(this.state.tar_id).then((response) =>{
            this.setState({load:true});    
        }).catch((error) =>{
           this.props.SetError(500);
        });

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:"Unidade Curricular",link:this.props.menu.missao.home},
            {action:true,nome:this.props.menu.missao.nomeModulo,link:`${this.props.menu.missao.missao_lista}/${this.state.tur_id}/${this.state.dis_id}`},
            {action:false,nome:'Resposta Aluno'},
           ]);

           this.props.GetListaSubMenuTopo([
            {nome:"Não Avaliado",link : null},
            {nome:"Avaliado",link : 1},
          ]);
          this.props.GetCheckSelect(null);
    }

    render() {

        const statusStyle = {color: "#d43d3d", 
                                    "marginTop": "15px" 
                                }

        const checkSelect = {};
        switch (this.props.checkSelect) {
            case null:
                 checkSelect.acao =  <MissaoRespostaList status={false} tar_id={this.state.tar_id}/>;       
            break;

            case 1:
                 checkSelect.acao =  <MissaoRespostaList status={true} tar_id={this.state.tar_id}/>;     
            break;
        
            default:
            break;
        }

        return (
            <div className="container-bg">
                 <div className="titulo-pages topo_conteudo">
                     <div className="titulo">{this.props.nome_turma==null? "Carregando..":this.props.nome_turma}</div>
                     <div className="pull-right" style={statusStyle}>{this.props.statusMissao===null? "Carregando..": (this.props.statusMissao === 2 ? <span>Missão encerrada</span>: "")}</div>
                 </div>
                {!this.state.load? <FlashCarregando/> : checkSelect.acao }
            </div>
       )
    }
}

function mapStateToProps(state){

    return {
            checkSelect : state.scopoReducer.checkSelect,
            menu        : state.configReducer.menu,
            statusMissao : state.tarefaReducer.statusMissao,
            nome_turma : state.tarefaReducer.nome_turma, 
           }
}

export default connect(mapStateToProps,{GetComponentesTarefas,
                             SetError,
                             GetListaMenuTopo,
                             GetListaSubMenuTopo,
                             GetCheckSelect})(Missao_Resposta);


// WEBPACK FOOTER //
// ./src/components/professor/missoes/missao_resposta.js